import { render, staticRenderFns } from "./noticeDialog.vue?vue&type=template&id=c8b4793e&scoped=true&"
import script from "./noticeDialog.vue?vue&type=script&lang=js&"
export * from "./noticeDialog.vue?vue&type=script&lang=js&"
import style0 from "./noticeDialog.vue?vue&type=style&index=0&id=c8b4793e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b4793e",
  null
  
)

export default component.exports